unit View.Facil_Planos.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewFacil_PlanosList = class(TForm)
    btNew: TButton;
    Facil_PlanosDataset: TXDataWebDataSet;
    Facil_PlanosDatasetid: TIntegerField;
    Facil_PlanosDatasetgrade_nome: TStringField;
    Facil_PlanosDatasetnome: TStringField;
    Facil_PlanosDatasetcodigo_interno: TIntegerField;
    Facil_PlanosDatasetexcluido: TBooleanField;
    Facil_PlanosDatasetinclusao: TDateTimeField;
    Facil_PlanosDatasetalteracao: TDateTimeField;
    Facil_PlanosDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewFacil_PlanosList: TFViewFacil_PlanosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewFacil_PlanosList }

procedure TFViewFacil_PlanosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewFacil_PlanosList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewFacil_PlanosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewFacil_PlanosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewFacil_PlanosList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewFacil_PlanosList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewFacil_PlanosList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Facil_PlanosDataset.Connection.Model.DefaultSchema.FindEntityType(Facil_PlanosDataset.EntitySetName),
      Facil_PlanosDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewFacil_PlanosList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('facil_planos', 'active');
  TUtils.SetValorDicionarioClasses('facil_planos_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_facil_planos', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Facil_PlanosDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewFacil_PlanosList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.facil_planos.list.pagination.info');
  btNew := TButton.Create('view.facil_planos.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.facil_planos.list.table');
  cbPageSize := TComboBox.Create('view.facil_planos.list.cbPageSize');
  edSearch := TEdit.Create('view.facil_planos.list.search');
  lcPaginator := TListControl.Create('view.facil_planos.list.pagination');
  Facil_PlanosDataset := TXDataWebDataSet.Create(Self);
  Facil_PlanosDatasetid := TIntegerField.Create(Self);
  Facil_PlanosDatasetgrade_nome := TStringField.Create(Self);
  Facil_PlanosDatasetnome := TStringField.Create(Self);
  Facil_PlanosDatasetcodigo_interno := TIntegerField.Create(Self);
  Facil_PlanosDatasetexcluido := TBooleanField.Create(Self);
  Facil_PlanosDatasetinclusao := TDateTimeField.Create(Self);
  Facil_PlanosDatasetalteracao := TDateTimeField.Create(Self);
  Facil_PlanosDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Facil_PlanosDataset.BeforeLoadDFMValues;
  Facil_PlanosDatasetid.BeforeLoadDFMValues;
  Facil_PlanosDatasetgrade_nome.BeforeLoadDFMValues;
  Facil_PlanosDatasetnome.BeforeLoadDFMValues;
  Facil_PlanosDatasetcodigo_interno.BeforeLoadDFMValues;
  Facil_PlanosDatasetexcluido.BeforeLoadDFMValues;
  Facil_PlanosDatasetinclusao.BeforeLoadDFMValues;
  Facil_PlanosDatasetalteracao.BeforeLoadDFMValues;
  Facil_PlanosDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewFacil_PlanosList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'grade_nome';
      Title := 'grade_nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Facil_PlanosDataset.SetParentComponent(Self);
    Facil_PlanosDataset.Name := 'Facil_PlanosDataset';
    Facil_PlanosDataset.EntitySetName := 'Facil_Planos';
    Facil_PlanosDataset.Connection := DMConnection.ApiConnection;
    Facil_PlanosDataset.Left := 72;
    Facil_PlanosDataset.Top := 144;
    Facil_PlanosDatasetid.SetParentComponent(Facil_PlanosDataset);
    Facil_PlanosDatasetid.Name := 'Facil_PlanosDatasetid';
    Facil_PlanosDatasetid.FieldName := 'id';
    Facil_PlanosDatasetid.Required := True;
    Facil_PlanosDatasetgrade_nome.SetParentComponent(Facil_PlanosDataset);
    Facil_PlanosDatasetgrade_nome.Name := 'Facil_PlanosDatasetgrade_nome';
    Facil_PlanosDatasetgrade_nome.FieldName := 'grade_nome';
    Facil_PlanosDatasetgrade_nome.Size := 255;
    Facil_PlanosDatasetnome.SetParentComponent(Facil_PlanosDataset);
    Facil_PlanosDatasetnome.Name := 'Facil_PlanosDatasetnome';
    Facil_PlanosDatasetnome.FieldName := 'nome';
    Facil_PlanosDatasetnome.Required := True;
    Facil_PlanosDatasetnome.Size := 255;
    Facil_PlanosDatasetcodigo_interno.SetParentComponent(Facil_PlanosDataset);
    Facil_PlanosDatasetcodigo_interno.Name := 'Facil_PlanosDatasetcodigo_interno';
    Facil_PlanosDatasetcodigo_interno.FieldName := 'codigo_interno';
    Facil_PlanosDatasetcodigo_interno.Required := True;
    Facil_PlanosDatasetexcluido.SetParentComponent(Facil_PlanosDataset);
    Facil_PlanosDatasetexcluido.Name := 'Facil_PlanosDatasetexcluido';
    Facil_PlanosDatasetexcluido.FieldName := 'excluido';
    Facil_PlanosDatasetinclusao.SetParentComponent(Facil_PlanosDataset);
    Facil_PlanosDatasetinclusao.Name := 'Facil_PlanosDatasetinclusao';
    Facil_PlanosDatasetinclusao.FieldName := 'inclusao';
    Facil_PlanosDatasetalteracao.SetParentComponent(Facil_PlanosDataset);
    Facil_PlanosDatasetalteracao.Name := 'Facil_PlanosDatasetalteracao';
    Facil_PlanosDatasetalteracao.FieldName := 'alteracao';
    Facil_PlanosDatasetexclusao.SetParentComponent(Facil_PlanosDataset);
    Facil_PlanosDatasetexclusao.Name := 'Facil_PlanosDatasetexclusao';
    Facil_PlanosDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Facil_PlanosDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Facil_PlanosDataset.AfterLoadDFMValues;
    Facil_PlanosDatasetid.AfterLoadDFMValues;
    Facil_PlanosDatasetgrade_nome.AfterLoadDFMValues;
    Facil_PlanosDatasetnome.AfterLoadDFMValues;
    Facil_PlanosDatasetcodigo_interno.AfterLoadDFMValues;
    Facil_PlanosDatasetexcluido.AfterLoadDFMValues;
    Facil_PlanosDatasetinclusao.AfterLoadDFMValues;
    Facil_PlanosDatasetalteracao.AfterLoadDFMValues;
    Facil_PlanosDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
